<template>
  <v-container id="user-register" fluid grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>

      <v-spacer class="my-2"></v-spacer>

      <v-flex xs12>
        <h2>{{ $vuetify.t('$vuetify.authentication.new_register') }}</h2>
      </v-flex>

      <v-spacer class="my-2"></v-spacer>

      <UserForm :customer=customer :newUser=newUser :setLoadedDefinitions="setLoadedDefinitions"
                :socialLogin="socialLogin"></UserForm>

      <v-spacer class="my-1"></v-spacer>

      <v-flex xs12>
        <div class="text-xs-center">
          <v-btn

              @click="submit"
              class="primary"
              large
          >
            {{ $vuetify.t('$vuetify.next') }}
            <v-icon right small>fal fa-angle-double-right</v-icon>
          </v-btn>
          <!--<v-btn @click="clear">Limpar</v-btn>-->
        </div>
      </v-flex>
    </v-form>
  </v-container>
</template>

<script>
import {userService} from '../../_services'
import UserForm from '../../components/UserForm.vue';
import {getErrorMessage, recaptchaHelper} from "../../_helpers";

//TODO mover isto para block css
import "clientEntryLayout"

export default {
  name: "UserRegister",
  components: {UserForm},
  data: () => ({
    customer: {},
    valid: true,
    loadedProfileDefinitions: false,
    loadedGenericDefinitions: false,
    username: null,
    loginProvider: null,
    loginCode: null,
    newUser: true,
    socialLogin: false,
  }),
  watch: {
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date)
    },
    /**
     * The UserForm (child component) on its mounted section, has to load the profile's configuration.
     * Only after the load is finished, the 'Save' button can be displayed as enabled.
     *
     * Therefore, it is the child component which is responsible to update the flags 'loadedProfileDefinitions'
     * and 'loadedGenericDefinitions' which control the 'Save' button through the 'isEnabled' function.
     * The child component updates the parent's properties using this function.
     * */
    setLoadedDefinitions(context, value) {
      if (context === "profile_definitions") {
        this.loadedProfileDefinitions = value;
      } else if (context === "generic_definitions") {
        this.loadedGenericDefinitions = value;
      }
    },
    submit() {
      /**
       * This function is responsible for submitting the information filled in on the User's Profile fields.
       * This submission consists on passing the User's Profile information to the backend, to build all the
       * necessary registers.
       *
       * Once the User's Profile is correctly filled in, it is possible to continue with the submission process.
       * 1st a loading layer is added to the interface
       *
       * 2nd an object is defined with all the information which will be passed to the backend
       * (some notes on this object: )
       *
       * 3rd the backend API service setnewcustomer is called to create a New Customer. This call is made by the
       * user module function setNewProfile.
       * (some notes on this service:
       *                              (1) - this service fills in the user's information
       *                              (2) - defines the user and customer registers,
       *                              (3) - defines a password to the user,
       *                              (4) - sends a sms to the user containing the password
       *
       * 4th having a success answer from the service the user is redirect to the Password Interface
       */
      if (this.$refs.form.validate()) {

        // 1 - setting the Loading Layer
        this.$store.dispatch("loader/setLoading", true);

        // 2 - an object is defined with all the information which will be passed to the backend
        let obj = {
          "name": this.customer.name,
          "birth_date": this.customer.birth_date,
          "email_address": this.customer.email_address ? this.customer.email_address.trim() : null,
          "telephone": this.customer.telephone,
          "tax_number": this.customer.tax_number,
          "gender": this.customer.gender ? this.customer.gender.value : null,
          "gdpr_agreement": this.customer.gdpr_agreement ? 1 : 0,
          "send_1": this.customer.send_communication_generally ? 1 : 0,
          "send_2": this.customer.send_communication_generally ? 1 : 0,
          "send_3": this.customer.send_communication_generally ? 1 : 0,
          "send_4": this.customer.send_communication_generally ? 1 : 0,
          "send_5": this.customer.send_communication_generally ? 1 : 0,
          "send_6": this.customer.send_6 ? 1 : 0,
          "send_7": this.customer.send_7 ? 1 : 0,
          "username": this.username ? this.username : this.selected_country_code + '-' + this.customer.telephone,
          "login_code": this.loginCode,
          "login_provider": this.loginProvider,
          "favourite_store": this.customer.favourite_store ? this.customer.favourite_store.value : null,
        };

        // 3 - the backend API service setnewcustomer is called to create a New Customer.
        // This call is made by the user module function setNewProfile.
        recaptchaHelper('createUser', this).then((token) => {
              obj.recaptcha_token = token;
              userService.setNewProfile(obj).then(result => {
                    //TODO VER DANIEL Validar com o Daniel verificar se quer assim ou se prefere que o result traga o username
                    //preciso disto porque no router asseguramos que só vamos pra login-auth se o username estiver definido na Store
                    this.$store.dispatch('authentication/setLoginUsername', obj.username);
                    this.$store.dispatch('authentication/setValidateProfile', result.mandatory_validate_profile);

                    this.$router.push({name: 'login-auth', params: {status: "newUser"}});

                    this.$store.dispatch("loader/setLoading", false);
                  },
                  error => {
                    getErrorMessage(error, 'Create User', this);
                  });
            },
            error => {
              getErrorMessage(error, 'Create User Recaptcha', this);
            });
      }
    },
    clear() {
      this.$refs.form.reset()
    }
  },
  computed: {
    /**
     * The UserForm on its mounted section, has to load the profile's configuration.
     * Only after the load is finished, the 'Save' button can be displayed as enabled.
     *
     * The two flags validated on the following lines,
     *  are the flags updated by the functions on the UserForm mounted section,
     *  through the 'setLoadedDefinitions' method.
     * @returns {boolean}
     */
    isEnabled() {
      return this.loadedProfileDefinitions && this.loadedProfileDefinitions;
    }
  },
  mounted() {
    // Called after the instance has been mounted:

    //  1 - getting from the store the username given on the 1st step (view LoginUsername);
    //      which was set on the authentication module by the setLoginUsername mutation
    // OR if the user chooses a Social Provider to Log In
    //  1 - getting from the store the Provider given on the 1st step (view LoginUsername);
    //      which was set on the authentication module by the setLoginProvider mutation
    this.username = this.$store.state.authentication.user.username;
    this.loginProvider = this.$store.state.authentication.login_provider.provider;
    this.loginCode = this.$store.state.authentication.login_provider.code;
    this.$log.debug("User Register | Getting the Username or the Social Provider");
    this.$log.debug("User Register | Username: ", this.username);
    this.$log.debug("User Register | Social Provider: ", this.loginProvider);
    this.$log.debug("User Register | Social Code: ", this.loginCode);

    // 2 - if the user accessed this view directly,
    // (this is possible to discover by analysing the Store's values of the username and provider. If both are undefined -> bad sign)
    //     the user should be redirected to the 1st step (view LoginUsername);
    // 2 - if everything is as expected the user can continue to the Profile interface
    if ((this.username === undefined || this.username === null) && (this.loginProvider === undefined || this.loginProvider === null)) {
      this.$router.push({name: "login"});
    }

    // 3 - if the user gives a mobile phone to Log In, it is possible to pre fill the User's Profile with this info.
    // OR
    // 3 - if the user chooses a Social Provider to Log In, it is possible to exist data to pre fill the User's Profile.
    // In this case, the information can be found on the Router Parameters
    if (this.username) {
      this.customer.telephone = this.username.split('-')[1];
    }
    if (this.loginProvider) {
      this.socialLogin = true;
      this.customer.name = this.$route.params.name;
      this.customer.email_address = this.$route.params.email_address;
      this.customer.gender = this.$route.params.gender;
      this.customer.birth_date = this.$route.params.birth_date;
      this.$log.debug("User Register | Getting the default information to fill in the Profile");
      this.$log.debug("User Register | Name: ", this.customer.name);
      this.$log.debug("User Register | Email: ", this.customer.email_address);
      this.$log.debug("User Register | Gender: ", this.customer.gender);
      this.$log.debug("User Register | Birthdate: ", this.customer.birth_date);
    }
  },
}
</script>

<style lang="stylus">

/****************************************** START CACULA *************************************************************/
/*#user-register
    .v-responsive.v-image.my-5
        height: 300px !important;*/

/****************************************** END CACULA *************************************************************/

/****************************************** START NAZ *************************************************************/

/*
    #user-register
        background: #EC0501 !important

        .theme--dark.v-label
            color: #FFFFFF !important

        .theme--dark.v-input:not(.v-input--is-disabled) input
            color: #fff !important
            caret-color: #fff !important

        .error--text
            color: #fd0 !important
            caret-color: #fd0 !important

        .theme--dark.v-icon.error--text
            color: #fd0 !important

        .theme--dark.v-icon
            color: #FFFFFF !important

        .v-text-field > .v-input__control > .v-input__slot:after,
        .v-text-field > .v-input__control > .v-input__slot:after
            border-color: #fff !important

        .v-responsive.v-image.my-5
            height: 300px !important;

        .theme--dark.v-text-field > .v-input__control > .v-input__slot::before
            border-color: #fff !important

        .fa-angle-double-right::before
            content: "\f105"

        .v-btn.primary
            background-color: #fff !important

        .v-btn.primary .v-btn__content,
        .v-btn.primary .v-icon
            color: #EC0501 !important

        // FONT SIZES CONFIG

        .v-btn
            font-size: 18px !important;

        .v-input,
        .v-label
            font-size 18px
*/
/******************************************** END NAZ *************************************************************/
</style>